export default __webpack_public_path__ + "assets/front/scss/classification-browsing.dc6a3223480136eaf0f39310de411dca.css";